import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../auth/AuthProvider';
import { hasSeededMsalSession } from '../auth/msalPlaywrightSeed';
import { AppBootScreen } from './loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const startedLoginRef = useRef(false);

  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      !hasSeededMsalSession() &&
      !startedLoginRef.current
    ) {
      startedLoginRef.current = true;
      navigate("/login");
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading || (!isAuthenticated && !hasSeededMsalSession())) {
    return <AppBootScreen title="Loading Cortex…" data-testid="auth-guard-loading" />;
  }

  return <>{children}</>;
};
